module.exports = __webpack_public_path__ + "img/product_xd_ng_3.7b05f9e2.jpg";